export default __webpack_public_path__ + "static/media/payment.771c62c0.svg";